// Safari 10 nomodule fix:
if ( window.MAIN_EXECUTED ) {
    throw new Error( '' )
}
window.MAIN_EXECUTED = true

// Polyfills:
import 'es6-promise/auto'
objectFitImages()

// requestIdleCallback:
window.requestIdleCallback = window.requestIdleCallback || function( handler ) {
	let startTime = Date.now()

	return setTimeout( function() {
		handler( {
			didTimeout: false,
			timeRemaining: function() {
				return Math.max( 0, 50.0 - ( Date.now() - startTime ) )
			}
		} )
	}, 1 )
}

window.cancelIdleCallback = window.cancelIdleCallback || function( id ) {
	clearTimeout( id )
}

// scrollTo:
window.scrollTo = window.scrollTo || function( x, y ) {
	window.scrollLeft = x
	window.scrollTop = y
}

// External Dependencies:
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import objectFitImages from 'object-fit-images'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import PageTracker from 'components/PageTracker/PageTracker'

// Internal Dependencies:
import SiteContainer from 'containers/SiteContainer'

// Redux:
import configureStore from 'store/configure-store'
const store = configureStore()

ReactDOM.render(
	<Provider store={ store }>
		<BrowserRouter>
			<Switch>
				<Route component={ PageTracker( SiteContainer ) } />
			</Switch>
		</BrowserRouter>
	</Provider>,

	document.getElementById( 'app' )
)



// WEBPACK FOOTER //
// ./app.jsx